import { styled } from "@mui/material";

import { Button } from "../../../../../../../../../components/Form";

export const NoWrapButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
  minWidth: "158px",
}));
